import Layout from '@/layout';

// 基础路由
const baseRoutes = [
  {
    path: '/',
    component: Layout,
    redirect: '/home',
    name: 'Layout',
    children: [
      {
        path: 'home',
        component: () => import('@/views/home/index'),
        name: 'Home',
        meta: { title: '工作台', affix: true }
      },
      {
        path: 'userInfo',
        component: () => import('@/views/account/userInfo'),
        name: 'UserInfo',
        meta: { title: '个人信息' }
      },
      {
        path: 'changePassword',
        component: () => import('@/views/account/changePassword'),
        name: 'ChangePassword',
        meta: { title: '修改密码' }
      },
      {
        path: 'functionModule',
        component: () => import('@/views/system/functionModule'),
        name: 'functionModule',
        meta: { title: '功能模块' }
      },
      {
        path: 'progressDetail/:id',
        component: () => import('@/views/internalTransfer/progressDetail'),
        name: 'progressDetail',
        meta: { title: '业务进度详情', activeMenu: '/internalTransfer' }
      },
      {
        path: 'allocation/:id',
        component: () => import('@/views/taskAllocation/allocation'),
        name: 'allocation',
        meta: { title: '分配任务', activeMenu: '/taskAllocation' }
      },
      {
        path: 'reportManagement/:id',
        component: () => import('@/views/experimentReport/reportManagement'),
        name: 'reportManagement',
        meta: { title: '报告详情', activeMenu: '/experimentReport' }
      }
    ]
  },
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    name: 'Login',
    hidden: true
  },
  /******** pageOffice页面（需在index.js中配置whiteList） Start ********/
  {
    path: '/pageOffice/report',
    name: 'pageOfficeReport',
    component: () => import('@/views/pageOffice/word'),
    meta: {
      title: 'pageOffice报告（合格）'
    }
  },
  {
    path: '/pageOffice/reportFail',
    name: 'pageOfficeReportFail',
    component: () => import('@/views/pageOffice/word'),
    meta: {
      title: 'pageOffice报告（不合格）'
    }
  },
  {
    path: '/audit/pageOffice/report',
    name: 'pageOfficeAuditReport',
    component: () => import('@/views/pageOffice/word'),
    meta: {
      title: 'pageOffice报告（合格）'
    }
  },
  {
    path: '/audit/pageOffice/reportFail',
    name: 'pageOfficeAuditReportFail',
    component: () => import('@/views/pageOffice/word'),
    meta: {
      title: 'pageOffice报告（不合格）'
    }
  },
  {
    path: '/reportManagement/pageOffice/report',
    name: 'pageOfficeExperimentReport',
    component: () => import('@/views/pageOffice/word'),
    meta: {
      title: 'pageOffice报告（合格）'
    }
  },
  {
    path: '/reportManagement/pageOffice/reportFail',
    name: 'pageOfficeExperimentReportFail',
    component: () => import('@/views/pageOffice/word'),
    meta: {
      title: 'pageOffice报告（不合格）'
    }
  }
  /******** pageOffice页面 End ********/
];

export default baseRoutes;
